// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * POC animated lobby — the EffectsLayer and its DOM one-shots.
 * Rules: transform / opacity only, every animation finite, no will-change, no translateZ.
 * The layer only exists while an effect is active (see EffectsLayer.tsx).
 */
.FGUI2GLGBlnI8ZV9zIw7 {
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: none;
  overflow: hidden;
}
/* ── First-load reveal: a dark curtain fading away under a light sweep ─────────────────────── */
.eryPW3yi5yewCvFBg_2Z {
  position: absolute;
  inset: 0;
  background: radial-gradient(120% 90% at 50% 40%, rgba(8, 8, 14, 0.82), rgba(4, 4, 8, 0.98));
  animation: evmzelA14ReXZC2wiRyU 750ms ease-in-out 250ms both;
}
/* Small layer (40vmin) scaled up 5x: the soft gradient hides the upscaling, the layer stays cheap. */
.LiA9NI9sIuFV2aMG6QIg {
  position: absolute;
  left: 50%;
  top: 42%;
  width: 40vmin;
  height: 40vmin;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 236, 170, 0.95) 0%, rgba(255, 200, 80, 0.45) 35%, rgba(255, 180, 40, 0) 70%);
  animation: NRw3W4s3BINF6BhYRHVC 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;
}
html[data-motion-tier='lite'] .eryPW3yi5yewCvFBg_2Z {
  animation-duration: 400ms;
  animation-delay: 0ms;
}
html[data-motion-tier='lite'] .LiA9NI9sIuFV2aMG6QIg {
  display: none;
}
@keyframes evmzelA14ReXZC2wiRyU {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes NRw3W4s3BINF6BhYRHVC {
  0% {
    transform: translate(-50%, -50%) scale(0.2);
    opacity: 0;
  }
  30% {
    opacity: 0.85;
  }
  100% {
    transform: translate(-50%, -50%) scale(5);
    opacity: 0;
  }
}
/* ── Game open: a light tunnel growing out of the pressed card ─────────────────────────────── */
.He16euPSmapZ7jDOMzWj {
  position: absolute;
  left: var(--fx-x, 50%);
  top: var(--fx-y, 50%);
  width: 40vmin;
  height: 40vmin;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.95) 0%, rgba(255, 220, 120, 0.7) 30%, rgba(60, 40, 10, 0.85) 62%, rgba(0, 0, 0, 0.95) 100%);
  animation: niS_kva0azgySn2P0fNp 450ms cubic-bezier(0.3, 0.6, 0.2, 1) both;
}
html[data-motion-tier='lite'] .He16euPSmapZ7jDOMzWj {
  animation-duration: 300ms;
}
@keyframes niS_kva0azgySn2P0fNp {
  0% {
    transform: translate(-50%, -50%) scale(0.15);
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(var(--fx-scale, 8));
    opacity: 0;
  }
}
/* ── Amount burst: a big number scaling in with a glow ─────────────────────────────────────── */
.Bh6GIyFGSt6vtkL8mS_E {
  position: absolute;
  left: 50%;
  top: 44%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  /* Static shadow: painted once into the layer, then only composited while it scales. */
  text-shadow: 0 0 18px rgba(255, 200, 60, 0.95), 0 0 42px rgba(255, 140, 0, 0.7), 0 2px 4px rgba(0, 0, 0, 0.8);
  animation: wiDHRoTq124NebMzrjBN 2200ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}
.W9L9OCAnjm9ypFISd7wg {
  font-family: var(--font-family-primary);
  font-size: clamp(16px, 4vmin, 28px);
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #ffe9a8;
}
.Lq5eHhCi_Oq_exsu0KYr {
  font-family: var(--font-family-numeric, 'San Francisco Bold');
  font-size: clamp(36px, 11vmin, 96px);
  font-weight: 800;
  line-height: 1;
}
html[data-motion-tier='lite'] .Bh6GIyFGSt6vtkL8mS_E {
  animation-duration: 1400ms;
}
@keyframes wiDHRoTq124NebMzrjBN {
  0% {
    transform: translate(-50%, -50%) scale(0.3);
    opacity: 0;
  }
  12% {
    transform: translate(-50%, -50%) scale(1.18);
    opacity: 1;
  }
  20% {
    transform: translate(-50%, -50%) scale(1);
  }
  82% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.12);
    opacity: 0;
  }
}
/* ── Canvas host ───────────────────────────────────────────────────────────────────────────── */
.qhdtrwgt2TegKRcG2Ynx {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/shared/effects/EffectsLayer.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;AACA,iGAAiG;AACjG;EACE,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;EAC3F,4DAAoD;AACtD;AACA,qGAAqG;AACrG;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,0HAA0H;EAC1H,yEAA4D;AAC9D;AACA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;AACA,iGAAiG;AACjG;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qJAAqJ;EACrJ,yEAA6D;AAC/D;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,4CAA4C;IAC5C,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,0DAA0D;IAC1D,UAAU;EACZ;AACF;AACA,iGAAiG;AACjG;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sFAAsF;EACtF,6GAA6G;EAC7G,0EAA6D;AAC/D;AACA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,4CAA4C;IAC5C,UAAU;EACZ;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,4CAA4C;IAC5C,UAAU;EACZ;AACF;AACA,iGAAiG;AACjG;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd","sourcesContent":["/**\n * POC animated lobby — the EffectsLayer and its DOM one-shots.\n * Rules: transform / opacity only, every animation finite, no will-change, no translateZ.\n * The layer only exists while an effect is active (see EffectsLayer.tsx).\n */\n.layer {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  pointer-events: none;\n  overflow: hidden;\n}\n/* ── First-load reveal: a dark curtain fading away under a light sweep ─────────────────────── */\n.reveal {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(120% 90% at 50% 40%, rgba(8, 8, 14, 0.82), rgba(4, 4, 8, 0.98));\n  animation: fxCurtainOut 750ms ease-in-out 250ms both;\n}\n/* Small layer (40vmin) scaled up 5x: the soft gradient hides the upscaling, the layer stays cheap. */\n.sweep {\n  position: absolute;\n  left: 50%;\n  top: 42%;\n  width: 40vmin;\n  height: 40vmin;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 236, 170, 0.95) 0%, rgba(255, 200, 80, 0.45) 35%, rgba(255, 180, 40, 0) 70%);\n  animation: fxSweep 900ms cubic-bezier(0.2, 0.7, 0.2, 1) both;\n}\n:global(html[data-motion-tier='lite']) .reveal {\n  animation-duration: 400ms;\n  animation-delay: 0ms;\n}\n:global(html[data-motion-tier='lite']) .sweep {\n  display: none;\n}\n@keyframes fxCurtainOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes fxSweep {\n  0% {\n    transform: translate(-50%, -50%) scale(0.2);\n    opacity: 0;\n  }\n  30% {\n    opacity: 0.85;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(5);\n    opacity: 0;\n  }\n}\n/* ── Game open: a light tunnel growing out of the pressed card ─────────────────────────────── */\n.tunnel {\n  position: absolute;\n  left: var(--fx-x, 50%);\n  top: var(--fx-y, 50%);\n  width: 40vmin;\n  height: 40vmin;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.95) 0%, rgba(255, 220, 120, 0.7) 30%, rgba(60, 40, 10, 0.85) 62%, rgba(0, 0, 0, 0.95) 100%);\n  animation: fxTunnel 450ms cubic-bezier(0.3, 0.6, 0.2, 1) both;\n}\n:global(html[data-motion-tier='lite']) .tunnel {\n  animation-duration: 300ms;\n}\n@keyframes fxTunnel {\n  0% {\n    transform: translate(-50%, -50%) scale(0.15);\n    opacity: 0;\n  }\n  30% {\n    opacity: 1;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(var(--fx-scale, 8));\n    opacity: 0;\n  }\n}\n/* ── Amount burst: a big number scaling in with a glow ─────────────────────────────────────── */\n.burst {\n  position: absolute;\n  left: 50%;\n  top: 44%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  /* Static shadow: painted once into the layer, then only composited while it scales. */\n  text-shadow: 0 0 18px rgba(255, 200, 60, 0.95), 0 0 42px rgba(255, 140, 0, 0.7), 0 2px 4px rgba(0, 0, 0, 0.8);\n  animation: fxBurst 2200ms cubic-bezier(0.2, 0.8, 0.2, 1) both;\n}\n.burstLabel {\n  font-family: var(--font-family-primary);\n  font-size: clamp(16px, 4vmin, 28px);\n  font-weight: 700;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #ffe9a8;\n}\n.burstAmount {\n  font-family: var(--font-family-numeric, 'San Francisco Bold');\n  font-size: clamp(36px, 11vmin, 96px);\n  font-weight: 800;\n  line-height: 1;\n}\n:global(html[data-motion-tier='lite']) .burst {\n  animation-duration: 1400ms;\n}\n@keyframes fxBurst {\n  0% {\n    transform: translate(-50%, -50%) scale(0.3);\n    opacity: 0;\n  }\n  12% {\n    transform: translate(-50%, -50%) scale(1.18);\n    opacity: 1;\n  }\n  20% {\n    transform: translate(-50%, -50%) scale(1);\n  }\n  82% {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1.12);\n    opacity: 0;\n  }\n}\n/* ── Canvas host ───────────────────────────────────────────────────────────────────────────── */\n.canvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layer": `FGUI2GLGBlnI8ZV9zIw7`,
	"reveal": `eryPW3yi5yewCvFBg_2Z`,
	"fxCurtainOut": `evmzelA14ReXZC2wiRyU`,
	"sweep": `LiA9NI9sIuFV2aMG6QIg`,
	"fxSweep": `NRw3W4s3BINF6BhYRHVC`,
	"tunnel": `He16euPSmapZ7jDOMzWj`,
	"fxTunnel": `niS_kva0azgySn2P0fNp`,
	"burst": `Bh6GIyFGSt6vtkL8mS_E`,
	"fxBurst": `wiDHRoTq124NebMzrjBN`,
	"burstLabel": `W9L9OCAnjm9ypFISd7wg`,
	"burstAmount": `Lq5eHhCi_Oq_exsu0KYr`,
	"canvas": `qhdtrwgt2TegKRcG2Ynx`
};
export default ___CSS_LOADER_EXPORT___;
